import {NextRouter} from 'next/router'

export default function getTrackPath(router: NextRouter, websiteId: string, orderId: string) {
  if (typeof router.query.isChat === 'string' && router.query.isChat === 'true') {
    return `/chat/${websiteId}/track/${orderId}`
  }
  return `/track/${orderId}`
}
